import { getLegalPage } from 'api/content'
import { getReferralCodeValidation } from 'api/promo'
import { useQuery } from '@tanstack/react-query'

export const useReferralCode = (referralCode: string) =>
  useQuery<any>(['referralCode', referralCode], () => getReferralCodeValidation(referralCode))

export const useFaq = (slug: string) =>
  useQuery<any>(['faq', slug], () => getLegalPage(slug), {
    select: ({ pageContent }) => pageContent.map((c: any) => ({
      question: c.title,
      answer: c.answer,
    })),
  })
